import React from 'react';
const ClubStickyFooterLg = ({ ...r }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 769 97" {...r}>
            <path d="M0 1h768v96H0z"></path>
            <g
                stroke="#fff"
                strokeLinecap="square"
                strokeWidth="0.5"
                clipPath="url(#banner-a)"
            >
                <path d="M56 25l16 8m-16 0l16 8m-16 0l16 8m-16 0l16 8m-16 0l16 8"></path>
            </g>
            <path
                fill="url(#banner-b)"
                fillOpacity="0.7"
                fillRule="evenodd"
                d="M107.52 1h107.52L107.52 97H0L107.52 1z"
                clipRule="evenodd"
            ></path>
            <path
                fill="url(#banner-c)"
                fillOpacity="0.8"
                fillRule="evenodd"
                d="M155.52 1h69.12L123.67 91.152A23.02 23.02 0 01108.34 97c-21.14 0-31.1-26.108-15.33-40.187L155.52 1z"
                clipRule="evenodd"
            ></path>
            <path
                fill="url(#banner-d)"
                fillOpacity="0.8"
                fillRule="evenodd"
                d="M208.49 6.848A23.02 23.02 0 01223.82 1c21.14 0 31.1 26.108 15.33 40.187l-55.96 49.965A23.02 23.02 0 01167.86 97c-21.14 0-31.099-26.108-15.33-40.187l55.96-49.965z"
                clipRule="evenodd"
            ></path>
            <path
                stroke="#fff"
                strokeWidth="0.5"
                d="M532 25c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12z"
                opacity="0.5"
            ></path>
            <circle cx="730" cy="69" r="1" fill="#fff"></circle>
            <circle cx="745" cy="69" r="1" fill="#fff"></circle>
            <circle cx="740" cy="59" r="1" fill="#fff"></circle>
            <circle cx="740" cy="64" r="1" fill="#fff"></circle>
            <circle cx="735" cy="69" r="1" fill="#fff"></circle>
            <circle cx="750" cy="69" r="1" fill="#fff"></circle>
            <circle cx="740" cy="69" r="1" fill="#fff"></circle>
            <circle cx="740" cy="74" r="1" fill="#fff"></circle>
            <circle
                cx="736.464"
                cy="65.464"
                r="1"
                fill="#fff"
                transform="rotate(-45 736.464 65.464)"
            ></circle>
            <circle
                cx="743.536"
                cy="72.536"
                r="1"
                fill="#fff"
                transform="rotate(-45 743.536 72.536)"
            ></circle>
            <circle
                cx="743.536"
                cy="65.465"
                r="1"
                fill="#fff"
                transform="rotate(45 743.536 65.465)"
            ></circle>
            <circle
                cx="736.464"
                cy="72.535"
                r="1"
                fill="#fff"
                transform="rotate(45 736.464 72.535)"
            ></circle>
            <circle cx="740" cy="79" r="1" fill="#fff"></circle>
            <path
                stroke="#fff"
                strokeWidth="0.5"
                d="M683.79 1H752l-71.571 65.558c-9.679 8.865-24.631 8.542-33.916-.733-8.684-8.673-8.684-22.736 0-31.41.286-.286.58-.564.882-.834L683.79 1z"
                clipRule="evenodd"
                opacity="0.5"
            ></path>
            <path
                stroke="#fff"
                strokeWidth="0.5"
                d="M712.488 1H768v11.732L720.127 58.36c-9.548 9.1-24.392 8.814-33.601-.646-8.701-8.937-8.701-23.427 0-32.364.242-.249.489-.492.742-.729L712.488 1z"
                clipRule="evenodd"
                opacity="0.5"
            ></path>
            <defs>
                <linearGradient
                    id="banner-b"
                    x1="983.955"
                    x2="-157.589"
                    y1="42.456"
                    y2="85.223"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" stopOpacity="0.5"></stop>
                    <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
                </linearGradient>
                <linearGradient
                    id="banner-c"
                    x1="535.05"
                    x2="17.151"
                    y1="40.22"
                    y2="78.83"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" stopOpacity="0.5"></stop>
                    <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
                </linearGradient>
                <linearGradient
                    id="banner-d"
                    x1="594.57"
                    x2="81.745"
                    y1="32.446"
                    y2="104.529"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" stopOpacity="0.5"></stop>
                    <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
                </linearGradient>
                <clipPath id="banner-a">
                    <path
                        fill="#fff"
                        d="M0 0h16v40H0z"
                        transform="translate(56 25)"
                    ></path>
                </clipPath>
            </defs>
        </svg>
    );
}

export default ClubStickyFooterLg;